import { procurementAPI } from "../../axios";

export const actions = {

    //Public Posts
    CreatePublicPostPRItem(context, data){
        return procurementAPI.post(`PublicPostedPrItem/Add`, data);
    },
    RemovePublicPostPRItem(context, data){
        return procurementAPI.delete(`PublicPostedPrItem/${data}`);
    },
    GetActivePublicPostPRItem(){
        return procurementAPI.get(`PublicPostedPrItem/Active`);
    },
    GetActivePublicPostPRItemByCampus(context, data){
        return procurementAPI.get(`PublicPostedPrItem/Active/Campus/${data}`);
    },
    GetArchivePublicPostPRItem(){
        return procurementAPI.get(`PublicPostedPrItem/Ended`);
    },
    GetArchivePublicPostPRItemByCampus(context, data){
        return procurementAPI.get(`PublicPostedPrItem/Ended/Campus/${data}`);
    },

    // Pr File
    CreatePublicPrFile(context, data){
        return procurementAPI.post(`PublicPostedPrFile/Create`, data);
    },
    GetPublicPrFile(context, data){
        return procurementAPI.get(`PublicPostedPrFile/${data}`);
    },
}